import { Modal, Button } from "react-bootstrap";

import React, { useState } from "react";

import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Box, Tab, Tabs } from "@mui/material";
const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const basicSchema = Yup.object().shape({
  amount: Yup.number().required("Amount is required"),
});

const AddCredit = ({ showModal, hideModal, id, data, getDrivers }) => {
const history = useNavigate();
const [showPocketWithdrwals, setShowPocketWithdrwals] = useState(false);

  // const getDrivers = async () => {
  //   const response = await axios.get("drivers/").then();
  // };

  const onSubmit = async (values, actions) => {
    await new Promise((resolve) => setTimeout(resolve, 1000));
    editDriver(values);
  };

  const {
    values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit,
    submitForm,
  } = useFormik({
    initialValues: {
      balance: data.balance,
      pocket: data.pocket,
      amount: "",
      firstName: data.firstName,
      lastName: data.lastName,
    },
    validationSchema: basicSchema,
    onSubmit,
  });

  const notifySuccess = () =>
    toast.info("Driver Credit Updated.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  const editDriver = async (e, i) => {
    try {
      const bodyFormData = new FormData();
      for (let value in values) {
        bodyFormData.append(value, values[value]);
        bodyFormData.append("id", id);
      }

      const responce = await axios.post("/updateCredit/" + id, bodyFormData);
      history("/drivers");
      hideModal();
      notifySuccess();
      getDrivers();
      console.log(responce.status);
    } catch (error) {
      notifyError();
    }
  };

  const [currentTab, setCurrentTab] = useState(0);
  const [withdrawAmount, setWithdrawAmount] = useState();
  const [withdrawAmountError, setWithdrawAmountError] = useState();

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const withdrawClickHandler = async () => {
    console.log("=========withdraw clicked=======");
    if (!withdrawAmount) {
      setWithdrawAmountError("withdraw amount is required");
    }
    if (parseFloat(withdrawAmount) > parseFloat(values.pocket)) {
      setWithdrawAmountError(
        "withdraw amount shouldn't be greater than pocket"
      );
    }

    const response = await axios.post("/withdrawals/" + data.id, {
      amount: parseFloat(withdrawAmount),
    });
    getDrivers();
    hideModal();
  };

  const withdrawChangeHandler = (e) => {
    setWithdrawAmountError("");
    setWithdrawAmount(e.target.value);
  };

  return (
    <form
      onSubmit={handleSubmit}
      autoComplete="off"
      encType="multipart/form-data"
    >
      <Modal
      style={{marginTop: "60px"}}
        show={showModal}
        onHide={hideModal}
        backdrop={false}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>Update Driver Credit</Modal.Title> */}
          <Tabs value={currentTab} onChange={handleTabChange}>
            <Tab label="Update Driver Credit" />
            <Tab label="Withdraw from Pocket" />
          </Tabs>
        </Modal.Header>
        {currentTab === 0 && (
          <TabPanel value={currentTab} index={0}>
            <Modal.Body>
              <div class="row">
                <div class="col-md-12">
                  <div class="card card-primary">
                    <div class="card-body">
                      <div class="form-group">
                        <label for="inputName">First Name </label>
                        <input
                          type="text"
                          name="firstName"
                          value={values.firstName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled
                          className={
                            errors.firstName && touched.firstName
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                        {errors.firstName && touched.firstName && (
                          <p className="error">{errors.firstName}</p>
                        )}
                      </div>

                      <div class="form-group">
                        <label for="inputName">Last Name</label>
                        <input
                          type="text"
                          name="lastName"
                          value={values.lastName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled
                          className={
                            errors.lastName && touched.lastName
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                        {errors.lastName && touched.lastName && (
                          <p className="error">{errors.lastName}</p>
                        )}
                      </div>
                      <div class="form-group">
                        <label for="inputName">Current Amount</label>
                        <input
                          type="text"
                          name="balance"
                          value={values.balance}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled
                          className={
                            errors.balance && touched.balance
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                        {errors.balance && touched.balance && (
                          <p className="error">{errors.balance}</p>
                        )}
                      </div>

                      <div class="form-group">
                        <label for="inputName">New Amout</label>
                        <input
                          type="number"
                          min="1"
                          id="inputName"
                          name="amount"
                          value={values.amount}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={
                            errors.amount && touched.amount
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                        {errors.amount && touched.amount && (
                          <p className="error">{errors.amount}</p>
                        )}
                      </div>

                      {/* <div class="form-group">
                    <label for="inputName">Withdraw from pocket</label>
                    <input
                      type="number"
                      min="1"
                      id="inputName"
                      name="amount"
                      value={values.amount}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        errors.amount && touched.amount
                          ? "form-control input-error"
                          : "form-control "
                      }
                    />
                    {errors.amount && touched.amount && (
                      <p className="error">{errors.amount}</p>
                    )}
                  </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-error" onClick={hideModal}>
                Cancel
              </button>

              <button
                disabled={isSubmitting}
                onClick={submitForm}
                className="btn btn-success"
                type="submit"
              >
                Update
              </button>
            </Modal.Footer>
          </TabPanel>
        )}

        {currentTab === 1 && (
          <TabPanel value={currentTab} index={1}>
            <Modal.Body>
              <div class="row">
                <div class="col-md-12">
                  <div class="card card-primary">
                    <div class="card-body">
                      <div class="form-group">
                        <label for="inputName">Current Pocket</label>
                        <input
                          type="text"
                          name="balance"
                          value={values.pocket}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          disabled
                          className={
                            errors.pocket && touched.pocket
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                        {errors.pocket && touched.pocket && (
                          <p className="error">{errors.pocket}</p>
                        )}
                      </div>

                      <div class="form-group">
                        <label for="inputName">Withdraw Amount</label>
                        <input
                          type="number"
                          min="1"
                          id="inputName"
                          name="amount"
                          value={withdrawAmount}
                          onChange={withdrawChangeHandler}
                          // onBlur={handleBlur}
                          className={
                            withdrawAmountError
                              ? "form-control input-error"
                              : "form-control "
                          }
                        />
                        {withdrawAmountError && (
                          <p className="error">{withdrawAmountError}</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button className="btn btn-error" onClick={hideModal}>
                Cancel
              </button>

              <button
                onClick={withdrawClickHandler}
                className="btn btn-success"
                // type="submit"
              >
                Withdraw
              </button>
            </Modal.Footer>
          </TabPanel>
        )}
      </Modal>
    </form>
  );
};

const TabPanel = ({ children, value, index }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
};

export default AddCredit;
